import getRandomNumberBetween from './get-random-number-between';

export default function generatePositionFromTime() {
  const msNow = new Date().getTime();
  const increment = getRandomNumberBetween(100, 200);
  return msNow + increment;
}
